var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStacks = function SvgStacks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 12.892 1.71 7.896 12 2.9l10.3 4.996zm0 4.104-9.69-4.705 1.47-.712 8.22 3.96 8.229-3.96 1.471.711zm0 4.104-9.69-4.706 1.47-.711 8.22 3.96 8.229-3.96 1.471.711zm0-9.665 7.323-3.539L12 4.358 4.687 7.896z"
  })));
};
export default SvgStacks;